module.exports = __webpack_public_path__ + "assets/207d2d91176b00e14c9e43e9369ef9e9.jpg";